import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';

import {
    Text,
    Input,
    InputWithEndAdornment,
    CheckboxGroup,
    FormGroup,
    Checkbox,
    TextField,
    TagAdd,
} from '../index';

export const PersonalHealthForm = ({ onChange, data, errors, onAddTag, minRows, disabledForm }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
            <Text $bold $fontSize="18px">
                Personal Health
            </Text>
            <div style={{ display: 'grid', gridTemplateColumns: '145px 145px', columnGap: '10px' }}>
                <InputWithEndAdornment
                    id="weight"
                    label="Weight"
                    placeholder="Weight"
                    name="weight"
                    onChange={(e) => {
                        if (e.target.value >= 0) {
                            onChange(e);
                        }
                    }}
                    required
                    value={data?.weight}
                    endAdornment={<InputAdornment position="end">kg.</InputAdornment>}
                    type="number"
                    helperText={errors.find((value) => value.property === 'weight')?.message}
                    disabled={disabledForm}
                    onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 3);
                    }}
                />
                <InputWithEndAdornment
                    id="height"
                    label="Height"
                    placeholder="Height"
                    name="height"
                    onChange={(e) => {
                        if (e.target.value >= 0) {
                            onChange(e);
                        }
                    }}
                    required
                    value={data?.height}
                    endAdornment={<InputAdornment position="end">cm.</InputAdornment>}
                    type="number"
                    helperText={errors.find((value) => value.property === 'height')?.message}
                    disabled={disabledForm}
                    onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 3);
                    }}
                />
            </div>

            {onAddTag && (
                <TagAdd
                    label="Client Tag"
                    data={data?.patientTag}
                    onAddTag={onAddTag}
                    disabled={disabledForm}
                />
            )}

            <Input
                id="drug"
                label="Drug Allergy"
                placeholder="Drug Allergy"
                value={data?.drugAllergy}
                name="drugAllergy"
                onChange={onChange}
                $inputMaxWidth="400px"
                disabled={disabledForm}
                max={100}
            />
            <Input
                id="chronicDeseases1"
                label="Chronic Diseases"
                placeholder="Chronic Diseases"
                name="chronicDeseases1"
                onChange={(e) => onChange(e)}
                value={data?.chronicDeseases1}
                $inputMaxWidth="400px"
                disabled={disabledForm}
                max={100}
            />

            <CheckboxGroup component="fieldset" label="Remark">
                <FormGroup
                    row
                    style={{
                        paddingLeft: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                        columnGap: '15px',
                    }}
                >
                    <Checkbox
                        label={<span style={{ marginLeft: '15px' }}>Pregnant</span>}
                        checked={data?.pregnant}
                        name="pregnant"
                        onChange={onChange}
                        disabled={disabledForm}
                    />
                    <Checkbox
                        label={<span style={{ marginLeft: '15px' }}>Smoker</span>}
                        checked={data?.smoker}
                        name="smoker"
                        onChange={onChange}
                        disabled={disabledForm}
                    />
                    <Checkbox
                        label={<span style={{ marginLeft: '15px' }}>Drinker</span>}
                        checked={data?.drinker}
                        name="drinker"
                        onChange={onChange}
                        disabled={disabledForm}
                    />
                </FormGroup>
            </CheckboxGroup>

            <TextField
                id="chronicDeseases2"
                label="Chronic Diseases"
                placeholder="Chronic Diseases"
                value={data?.chronicDeseases2}
                name="chronicDeseases2"
                onChange={(e) => onChange(e)}
                $inputMaxWidth="640px"
                minRows={minRows}
                disabled={disabledForm}
                inputProps={{ maxLength: 2000 }}
            />
            <TextField
                id="familyMedicalRecord"
                label="Family Medical Record"
                placeholder="Family Medical Record"
                value={data?.familyMedicalRecord}
                name="familyMedicalRecord"
                onChange={(e) => onChange(e)}
                $inputMaxWidth="640px"
                minRows={minRows}
                disabled={disabledForm}
                inputProps={{ maxLength: 2000 }}
            />
        </div>
    );
};

PersonalHealthForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.object),
    onAddTag: PropTypes.func,
    minRows: PropTypes.number,
};
